export default __webpack_public_path__ + "static/media/dogs-logo.c3c8dd18.png";